import React from 'react';
import { Check } from 'lucide-react';
export function PainSection() {
  const painPoints = ['La comida (incluso la más sana) se queda atrapada en tu tracto digestivo más tiempo del debido.', 'Comienza a fermentar, generando gases nocivos y toxinas que se filtran a tu sangre.', 'Tu abdomen se inflama por una respuesta inmunitaria, dejándote pesada, sin energía y con esa sensación de "panza de embarazo" al final del día.'];
  return <section className="py-14 bg-white/60 relative overflow-hidden backdrop-blur-sm" data-id="element-432">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-433">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center max-w-7xl mx-auto" data-id="element-434">
          {/* Image Side */}
          <div className="mb-12 lg:mb-0 relative" data-id="element-435">
            <div className="relative rounded-3xl overflow-hidden shadow-xl border-8 border-cream" data-id="element-436">
              <img src="https://cdn.magicpatterns.com/uploads/98trXg9cf3YQCrBoQCnage/mujersonriente.png" alt="Mujer sonriente y saludable" className="w-full h-auto object-cover" data-id="element-437" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gold/20 rounded-full blur-2xl -z-10" data-id="element-438"></div>
          </div>

          {/* Content Side */}
          <div data-id="element-439">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-black mb-8 leading-tight" data-id="element-440">
              ¿Te despertás plana y terminás el día como un globo? Esto es lo
              que realmente está pasando en tu cuerpo.
            </h2>

            <div className="space-y-6 text-lg text-sage/90 mb-8" data-id="element-441">
              <p data-id="element-442">
                No es lo que comiste. No es que "te pasaste". No es la edad. Es
                que nadie te explicó que después de los 40, tu cuerpo juega con{' '}
                <strong data-id="element-443">reglas completamente diferentes</strong>.
              </p>
              <p data-id="element-444">
                Imaginá que tu intestino tiene un{' '}
                <strong data-id="element-445">camión de basura nocturno</strong>. Su trabajo es pasar
                todas las noches, limpiar los residuos digestivos del día y
                dejar todo en cero para empezar de nuevo. Ese camión se llama{' '}
                <strong data-id="element-446">Complejo Motor Migratorio (CMM)</strong>.
              </p>
              <p data-id="element-447">
                Después de los 40, los <strong data-id="element-448">cambios hormonales</strong> y el{' '}
                <strong data-id="element-449">estrés crónico</strong> hacen que ese camión deje de
                hacer su ruta. Se queda parado en el garaje. Y cuando el camión
                de basura no pasa, <strong data-id="element-450">la basura se acumula</strong>.
              </p>
            </div>

            <div className="bg-gradient-to-br from-cream to-mint/30 rounded-2xl p-8 mb-8 border border-sage/10 shadow-sm" data-id="element-451">
              <ul className="space-y-5" data-id="element-452">
                {painPoints.map((point, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-453">
                    <div className="mt-1 bg-sage/10 p-1 rounded-full flex-shrink-0" data-id="element-454">
                      <Check className="w-5 h-5 text-sage" data-id="element-455" />
                    </div>
                    <span className="text-sage font-medium" data-id="element-456">{point}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-mint/40 rounded-2xl p-6 mb-8 border border-emerald-200" data-id="element-457">
              <p className="text-lg font-serif italic text-black font-semibold" data-id="element-458">
                "Este Protocolo no es otra dieta. Es el mecanismo que vuelve a
                poner en marcha el camión de basura de tu intestino para que tu
                cuerpo se limpie solo, cada noche, como lo hacía antes."
              </p>
            </div>

            <div className="border-l-4 border-gold pl-6 py-2" data-id="element-459">
              <p className="text-lg font-medium text-sage/90" data-id="element-460">
                Es hora de dejar de pelear con tu cuerpo y empezar a trabajar a
                favor de tu biología.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}